<template>
  <Popover v-model:open="isOpen">
    <PopoverTrigger>
      <slot />
    </PopoverTrigger>
    <PopoverContent class="w-80 p-3" @open-auto-focus="onOpenAutoFocus">
      <div class="flex flex-col gap-2">
        <Input
          ref="inputRef"
          v-model="url"
          placeholder="https://example.com"
          size="sm"
          @keydown.enter="applyLink"
          @keydown.escape="isOpen = false"
        />
        <div class="flex items-center gap-2">
          <Button size="sm" class="flex-1" @click="applyLink">
            Применить
          </Button>
          <Button
            v-if="hasLink"
            variant="destructive"
            size="sm"
            @click="removeLink"
          >
            Удалить
          </Button>
        </div>
      </div>
    </PopoverContent>
  </Popover>
</template>

<script setup>
import { ref, watch, nextTick } from "vue";
import { Popover, PopoverTrigger, PopoverContent } from "@/shared/ui/popover";
import Input from "@/shared/ui/input/Input.vue";
import Button from "@/shared/ui/button/Button.vue";

const props = defineProps({
  editor: {
    type: Object,
    required: true,
  },
});

const isOpen = ref(false);
const url = ref("");
const inputRef = ref(null);

const hasLink = ref(false);

watch(isOpen, (open) => {
  if (open) {
    const attrs = props.editor.getAttributes("link");
    url.value = attrs.href || "";
    hasLink.value = !!attrs.href;
  }
});

function onOpenAutoFocus(event) {
  event.preventDefault();
  nextTick(() => {
    const input = inputRef.value?.$el || inputRef.value;
    if (input?.focus) input.focus();
  });
}

function applyLink() {
  const href = url.value.trim();
  if (!href) return;

  props.editor.chain().focus().extendMarkRange("link").setLink({ href }).run();

  isOpen.value = false;
}

function removeLink() {
  props.editor.chain().focus().extendMarkRange("link").unsetLink().run();

  isOpen.value = false;
}
</script>
